import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from '../services/profile.service';
import { LoadingController } from '@ionic/angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { pluck, first } from 'rxjs/operators';
import { from } from 'rxjs';
import { ShareService } from '../share.service';
import { EnvService } from '../env.service';
import { AlertService } from '../alert.service';
import { TimezoneService } from '../services/timezone.service';
declare var amplitude;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  loadingStudioData = true;
  user;
  userUrl = '';
  messageBody = '';
  facebookShareUrl: string;
  twitterShareUrl: string;
  emailBody: string;
  promotions = [];
  showMore: boolean;
  fullName = '';
  constructor(
    public shareService: ShareService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private loadingCtrl: LoadingController,
    private router: Router,
    private env: EnvService,
    private alertService: AlertService,
    public timezoneService: TimezoneService
    ) {
    }
  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params.username) {
        this.getUserDetails(params.username);
        // this.getPromotions(params.id);
        amplitude.logEvent("mobile::visited_profile_page", {'instructorId': params.username});
       }
    });
  }
  getUserDetails(username) {
    this.fullName = '';
    this.profileService.getUserByUsername(username).subscribe((response: any) => {
      this.user = response.result;
      this.getPromotions(this.user.id);
      this.fullName = this.user.first_name + this.user.last_name + this.user.username;
      this.user.certs = this.user.certifications.map((item) => item.name).join(',');
      this.createShareMessage();
    }, (err) => {
    });
  }

  getNextSessionTimestamp(promotion) {
    return _(promotion.next_sessions)
      .map('startdate_timestamp')
      .sortBy()
      .first();
  }

  getLastClassDate(promotion) {
    return _(promotion.next_sessions)
    .map('startdate_timestamp')
    .sortBy()
    .last();
  }

  getPromotions(id) {
    this.promotions = [];

    const RE = /^(\d+)/;
    this.profileService.getUserPromotions(id).subscribe((response: any) => {
      this.promotions = this.filterPromotions(response.result);
      this.promotions.forEach((promo) => {
        const results = String(promo.session_value).match(RE);
        if (results && results[1]) {
          switch (results[1]) {
              case '1':
                  promo.sessionsText = 'Drop-in Session';
                  break;
              default:
                promo.sessionsText = results[1] + ' Sessions';
          }
        } else {
            promo.sessionsText = promo.session_value;
        }
        const next_sessions = from(promo.next_sessions);
        const list = [];
        next_sessions.pipe(pluck('startdate_timestamp')).subscribe( val => list.push(val));
        promo.start_date = _(list).sortBy().first();
        promo.end_date = _(list).sortBy().last();
      });
    }, (err) => {
    });
  }

  filterPromotions(promotions){
    return promotions.filter( (item) => {
      return (item.user_id == this.user.id && ((item.classes.instructor.is_invited == 1 && item.classes.instructor.invitation_status != 'ACCEPTED') ||
      (item.classes.instructor.is_invited == 1 && item.classes.instructor.invitation_status == 'ACCEPTED' && !item.classes.instructor.is_profile_completed)))
      || (item.classes.instructor.id == this.user.id && (item.classes.instructor.is_invited != 1 || (item.classes.instructor.invitation_status == 'ACCEPTED' && item.classes.instructor.is_profile_completed)));           
    });
  }

  showLoader() {
    this.loadingCtrl.create({
        message: 'Loading...',
        backdropDismiss: true,
        id: 'profileLoader'
    }).then((res) => {
        res.present();
        res.onDidDismiss();
    });
  }
  hideLoader() {
    const modal = this.loadingCtrl.getTop().then((m) => {
      m.dismiss();
    });
  }
  showPromotionDetails(promo) {
    this.router.navigate(['/promotion', promo.id]);
  }

  shareFacebook() {
    this.shareService.shareToFacebook(this.env.BASE_URL + this.user.username);
  }

  copyUrlToClipboard(){
    const tempElement = document.createElement('textarea');
    tempElement.value = this.env.BASE_URL + this.user.username;
    tempElement.setAttribute('readonly', '');
    tempElement.style.position = 'absolute';
    tempElement.style.left = '-9999px';
    document.body.appendChild(tempElement);
    tempElement.select();
    document.execCommand('copy');
    document.body.removeChild(tempElement);
    this.alertService.presentToast('Link Copied!');
  }

  createShareMessage() {
    var nl = encodeURI("\n\r");
    const messageBody =
        'Hi' +
            nl + nl + 'Check out this instructor\'s profile on Promoga!' +
            nl + this.user.first_name + ' ' + this.user.last_name +
            nl + nl + this.shareService.shareToEmail(this.env.BASE_URL + this.user.username) +
            nl + nl + 'Cheers,';
      this.emailBody = messageBody;
      this.twitterShareUrl = this.shareService.shareToTwitter(this.env.BASE_URL + this.user.username);
    }
  

  serchByPromoter(){
    let params = this.getBoundingBox();
    params['promoter'] = this.user.id;
    this.router.navigate(['/search/promotions'], 
    { queryParams: params }).then(() => {
      // window.location.reload();
    });
  }

  getBoundingBox() {
    let resLat = 49.26952433851487;
    let resLng = -122.97970844335937;
    if(this.promotions && this.promotions.length > 0){
       resLat = parseFloat(this.promotions[0].classes.venue.lat);
       resLng = parseFloat(this.promotions[0].classes.venue.lng);
    }

    const offsetLat = 0.35;
    const offsetLng = 0.35;

    return {
      sw_lat: (resLat - offsetLat).toFixed(10),
      sw_lng: (resLng - offsetLng).toFixed(10),
      ne_lat: (resLat  + offsetLat).toFixed(10),
      ne_lng: (resLng  + offsetLng).toFixed(10),
      resLat: resLat,
      resLng: resLng                                    
    };
}

  convertTimeToUserTimezone(nextSessionDate, promo){
    return this.timezoneService.convertUtcToUserTimezone(nextSessionDate, this.isOnlineActivity(promo.classes), promo.classes.venue.time_zone);
  }

  isOnlineActivity(cls){
    return cls.online_locations && cls.online_locations.length > 0;
  }
}
